import React from 'react';
// @ts-ignore
import { Heading, Loader } from 'arag-ui-lib';
import SurveyFormWrapper from '../surveyForm/surveyFormWrapper';

type Props = {
    questions: any;
    onSubmitSurvey: any;
    heading: string;
    posting: boolean;
};
const SingleSurvey = (props: Props): JSX.Element => {
    const { questions, heading, onSubmitSurvey, posting } = props;

    return (
        <>
            <SurveyFormWrapper
                questions={questions}
                onSubmitSurvey={onSubmitSurvey}
                heading={heading}
                posting={posting}
            />
        </>
    );
};

export default SingleSurvey;
